import BiggerPicture from 'bigger-picture'
import $ from "jquery";

const BigPicture = (($) => {
  function prepareItems(items) {
    if (!items.length) return;

    for (const link of items) {
      const img = link.querySelector('img');
      const caption = link.dataset.caption || link.getAttribute('title') || img?.getAttribute('alt') || '';

      if (caption && !link.dataset.caption) {
        link.dataset.caption = caption;
      }
    }
  }

  function isMobileResolution() {
    return window.innerWidth <= 767;
  }

  function shouldUseReducedScale() {
    return !isMobileResolution() && window.innerHeight <= 800;
  }

  function getOpenOptions(items, currentTarget) {
    const options = {
      items,
      el: currentTarget,
      maxZoom: 2,
    };

    if (shouldUseReducedScale()) {
      options.scale = 0.8;
    }

    return options;
  }

  function bindGallery(items) {
    if (!items.length) return;

    prepareItems(items);

    const bp = BiggerPicture({
      target: document.body,
    });

    for (const link of items) {
      if (link.dataset.bpBound === 'true') continue;

      link.dataset.bpBound = 'true';
      link.addEventListener('click', openGallery);
    }

    function openGallery(e) {
      e.preventDefault();

      bp.open(getOpenOptions(items, e.currentTarget));
    }
  }

  function initStandaloneGalleries() {
    const galleries = document.querySelectorAll('.bigger__picture');

    for (const gallery of galleries) {
      if (gallery.closest('.js-slider')) continue;

      bindGallery(Array.from(gallery.querySelectorAll('a')));
    }
  }

  function initSliderGallery(slider) {
    bindGallery(Array.from(slider.querySelectorAll('.bigger__picture > a')));
  }

  function waitForOwl() {
    const sliders = $('.js-slider');

    initStandaloneGalleries();

    if (!sliders.length) return;

    sliders.each(function () {
      const $slider = $(this);
      const slider = this;

      // если owl уже инициализирован
      if ($slider.hasClass('owl-loaded')) {
        initSliderGallery(slider);
        return;
      }

      // если ещё нет — ждём событие
      $slider.one('initialized.owl.carousel', function () {
        initSliderGallery(slider);
      });
    });
  }

  function initWhenDomReady() {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', waitForOwl, { once: true });
      return;
    }

    waitForOwl();
  }

  initWhenDomReady();

})(jQuery);

export default BigPicture;
